import {
  UPDATE_USER_DATA,
  UPDATE_ETE_SIGNATURE,
  UPDATE_TRANS_SESS_ID,
  TOGGLE_LOGIN_HAPPENING,
  RESET_LOGIN,
  UPDATE_PROFILE,
  UPDATE_EXPORT_CONTROL_BLOCK,
  UPDATE_ACCOUNTS_CSNS,
  UPDATE_BLOCKED_CSN,
  UPDATE_BLOCKED_ACCOUNT_NAME
} from '../actions/types';

const initialState = {
  userDetails: {},
  userEntitlements: {},
  analyticsId: null,
  eteSessionSign: null,
  transactionSessionId: null,
  loginHappening: false,
  mcvisid: null,
  profile: {}, // user Profile from dotcom page session storage.
  isExportControlBlock: false,
  accountCSNs: [],
  blockedCSN: null,
  blockedAccountName: ''
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER_DATA:
      return action.payload;
    case UPDATE_ETE_SIGNATURE:
      return {
        ...state,
        eteSessionSign: action.payload,
      };
    case UPDATE_TRANS_SESS_ID:
      return {
        ...state,
        transactionSessionId: action.payload,
      };
    case TOGGLE_LOGIN_HAPPENING:
      return {...state, loginHappening: action.payload};
    case UPDATE_PROFILE:
      return {...state, profile: action.payload};
    case UPDATE_EXPORT_CONTROL_BLOCK:
      return {...state, isExportControlBlock: action.payload};
    case UPDATE_ACCOUNTS_CSNS:
      return {...state, accountCSNs: action.payload};
    case UPDATE_BLOCKED_CSN:
      return {...state, blockedCSN: action.payload};
    case UPDATE_BLOCKED_ACCOUNT_NAME:
      return {...state, blockedAccountName: action.payload};
    case RESET_LOGIN:
      return {
        ...state,
        loginHappening: true,
        userDetails: {},
        userEntitlements: {},
        mcvisid: null,
        profile: {},
        isExportControlBlock: false,
        accountCSNs: [],
        blockedCSN: null,
        blockedAccountName: ''
      };
    default:
      return state;
  }
};

export default userReducer;
